<template>
  <generic-modal
    size="large"
    :title="$t('student inscription configuration')"
    icon="settings"
    image="/images/icons/sign.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="finished"
  >
    <div class="description">
      <div class="ui five item top attached tabular menu" ref="tabs_general">
        <a class="active item" data-tab="rules">{{ $t("rules") }}</a>
        <a class="item" data-tab="script">{{ $t("on show script") }}</a>
        <a class="item" data-tab="student_selected">{{
          $t("on student selected script")
        }}</a>
        <a class="item" data-tab="receipt">{{ $t("receipt") }}</a>
        <a class="item" data-tab="integration">{{ $t("integration") }}</a>
      </div>
      <div class="ui bottom attached active tab segment" data-tab="rules">
        <div class="ui form">
          <div class="two fields">
            <div class="eight wide column field">
              <label for>{{ $t("inscription rule") }}</label>
              <div class="ui selection dropdown" ref="rule_dropdown">
                <input type="hidden" name="ddwn" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu">
                  <div class="item" data-value="branch-based">
                    {{ $t("branch based") }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="eight wide column field">
              <label for>{{ $t("options") }}</label>
              <div class="ui toggle checkbox">
                <input
                  type="checkbox"
                  name="free_inscription_new_student"
                  v-model="conf.free_inscription_new_student"
                />
                <label>{{ $t("free inscription for new students") }}</label>
              </div>
            </div> -->
          </div>
          <div class="ui top attached tabular menu" ref="tabs">
            <a class="active item" data-tab="branch_based">{{
              $t("branch based")
            }}</a>
            <!-- <a class="item" data-tab="second">...</a> -->
          </div>
          <div
            class="ui bottom attached active tab segment"
            data-tab="branch_based"
          >
            <div class="ui grid">
              <div class="four wide column">
                <div
                  class="ui vertical fluid secondary pointing menu"
                  ref="branches_tabs"
                >
                  <a
                    class="item"
                    :data-tab="'branch_' + index"
                    v-for="(branch, index) in conf.branch_based.branches"
                    :key="index"
                  >
                    {{ branch.branch.name }}
                  </a>
                </div>
              </div>
              <div class="twelve wide stretched column">
                <div
                  class="ui tab segment"
                  style="margin-top:0"
                  :data-tab="'branch_' + index"
                  v-for="(branch, index) in conf.branch_based.branches"
                  :key="index"
                >
                  <div class="eight wide column field">
                    <label for>{{ $t("movement to charge") }}</label>
                    <div
                      class="ui selection dropdown"
                      ref="movement_dropdown"
                      :data-branch="branch.branch.uuid"
                    >
                      <input type="hidden" name="ddwn" />
                      <i class="dropdown icon"></i>
                      <div class="default text"></div>
                      <div class="menu"></div>
                    </div>
                  </div>
                  <div class="ui relaxed list">
                    <div
                      class="item"
                      v-for="(mv, idx) in branch.movements"
                      :key="idx"
                    >
                      <i class="large green check middle aligned icon"></i>
                      <div class="content">
                        <div class="ui grid">
                          <div class="two wide column">
                            <div class="field">
                              <label for v-if="idx == 0">{{
                                $t("quantity")
                              }}</label>
                              <input
                                type="text"
                                v-model="
                                  conf.branch_based.branches[index].movements[
                                    idx
                                  ].quantity
                                "
                              />
                            </div>
                          </div>
                          <div class="eight wide column">
                            <div class="field">
                              <label for v-if="idx == 0">{{
                                $t("movement type")
                              }}</label>
                              <h4 class="ui header">{{ mv.movement.name }}</h4>
                            </div>
                          </div>
                          <div class="three wide column">
                            <div class="field">
                              <label for v-if="idx == 0">{{
                                $t("amount")
                              }}</label>
                              <input
                                type="text"
                                v-model="
                                  conf.branch_based.branches[index].movements[
                                    idx
                                  ].amount
                                "
                              />
                            </div>
                          </div>
                          <div class="three wide column">
                            <div class="field">
                              <label for v-if="idx == 0">{{
                                $t("options")
                              }}</label>
                              <div
                                class="ui basic icon button"
                                :data-tooltip="$t('delete')"
                                @click="remove_mv(branch, index, mv, idx)"
                              >
                                <i class="red trash icon"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="ui top attached tabular menu" >
              <a
                class="item"
                :data-tab="'branch_' + index"
                v-for="(branch, index) in conf.branch_based.branches"
                :key="index"
                >{{ branch.branch.name }}</a
              >
            </div>
            <div
              class="ui bottom attached tab segment"
              :data-tab="'branch_' + index"
              v-for="(branch, index) in conf.branch_based.branches"
              :key="index"
            >
              <div class="eight wide column field">
                <label for>{{ $t("movement to charge") }}</label>
                <div
                  class="ui selection dropdown"
                  ref="movement_dropdown"
                  :data-branch="branch.branch.uuid"
                >
                  <input type="hidden" name="ddwn" />
                  <i class="dropdown icon"></i>
                  <div class="default text"></div>
                  <div class="menu"></div>
                </div>
              </div>
              <div class="ui relaxed list">
                <div
                  class="item"
                  v-for="(mv, idx) in branch.movements"
                  :key="idx"
                >
                  <i class="large green check middle aligned icon"></i>
                  <div class="content">
                    <div class="ui grid">
                      <div class="two wide column">
                        <div class="field">
                          <label for v-if="idx == 0">{{
                            $t("quantity")
                          }}</label>
                          <input
                            type="text"
                            v-model="
                              conf.branch_based.branches[index].movements[idx]
                                .quantity
                            "
                          />
                        </div>
                      </div>
                      <div class="eight wide column">
                        <div class="field">
                          <label for v-if="idx == 0">{{
                            $t("movement type")
                          }}</label>
                          <h4 class="ui header">{{ mv.movement.name }}</h4>
                        </div>
                      </div>
                      <div class="three wide column">
                        <div class="field">
                          <label for v-if="idx == 0">{{ $t("amount") }}</label>
                          <input
                            type="text"
                            v-model="
                              conf.branch_based.branches[index].movements[idx]
                                .amount
                            "
                          />
                        </div>
                      </div>
                      <div class="three wide column">
                        <div class="field">
                          <label for v-if="idx == 0">{{ $t("options") }}</label>
                          <div
                            class="ui basic icon button"
                            :data-tooltip="$t('delete')"
                            @click="remove_mv(branch, index, mv, idx)"
                          >
                            <i class="red trash icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <!-- <div class="ui bottom attached tab segment" data-tab="second">
            
          </div> -->
        </div>
      </div>
      <div class="ui bottom attached tab segment" data-tab="script">
        <div class="ui info message">
          <h4 class="header">
            {{
              $t(
                "this script will run after loading inscription modal is shown",
              )
            }}
          </h4>
          <h5 class="head">{{ $t("hints") }}</h5>
          <ul class="list">
            <li v-html="$t('use D to refer data objects')"></li>
          </ul>
        </div>
        <div class="field">
          <div class="ui toggle checkbox" style="margin-bottom:15px">
            <input
              type="checkbox"
              name="run_script"
              v-model="conf.run_script"
            />
            <label>{{ $t("run script on inscription modal shown") }}</label>
          </div>
        </div>
        <code-editor
          v-model="conf.script"
          :title="$t('script editor')"
          type="javascript"
          :show_format="true"
        />
      </div>
      <div class="ui bottom attached tab segment" data-tab="student_selected">
        <div class="ui info message">
          <h4 class="header">
            {{ $t("this script will run after student selected has changed") }}
          </h4>
          <h5 class="head">{{ $t("hints") }}</h5>
          <ul class="list">
            <li v-html="$t('use D to refer data objects')"></li>
          </ul>
        </div>
        <div class="field">
          <div class="ui toggle checkbox" style="margin-bottom:15px">
            <input
              type="checkbox"
              name="run_on_student_selected"
              v-model="conf.run_on_student_selected"
            />
            <label>{{ $t("run script on student selected changed") }}</label>
          </div>
        </div>
        <code-editor
          v-model="conf.script_student_selected"
          :title="$t('script editor')"
          type="javascript"
          :show_format="true"
        />
      </div>
      <div class="ui bottom attached tab segment" data-tab="receipt">
        <div class="ui toggle checkbox" style="margin-bottom:15px">
          <input
            type="checkbox"
            name="print_receipt"
            v-model="conf.print_receipt"
          />
          <label>{{ $t("print receipt on inscription finished") }}</label>
        </div>
        <templates :configuration="conf" ref="templates" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="integration">
        <integration :conf="conf" />
      </div>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import Templates from "./Templates.vue";
import Integration from "./Integration.vue";
import { local_api, stringify } from "@/utils";
import CodeEditor from "@/components/code_editor/Index";

export default {
  name: "StudentInscriptionConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    Templates,
    CodeEditor,
    Integration,
  },
  computed: {},
  data() {
    return {
      conf: {
        rule: "",
        branch_based: {
          branches: [],
        },
        // free_inscription_new_student: false,
        receipt_layouts: [],
        print_receipt: false,
        create_portal_user: false,
        send_to_assignation: false,
        show_pensum_courses: false,
        script: "",
        run_script: false,
        run_on_student_selected: false,
        script_student_selected: "",
        season_rule: "",
        season: "",
      },
      branches: [],
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let lyts = vm.$refs.templates.get_data();
        vm.conf.receipt_layouts = lyts;
        local_api(vm, "post", "/student_inscription/do-save-configuration", {
          s: vm.conf,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    remove_mv(branch, branchIndex, movement, index) {
      this.conf.branch_based.branches[branchIndex].movements.splice(index, 1);
    },
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/student_inscription/do-get-configuration")
      .then((conf) => {
        if (conf) {
          let stp = JSON.parse(conf.setup);
          if (stp.rule) {
            window
              .jQuery(vm.$refs.rule_dropdown)
              .dropdown("set selected", stp.rule);
          }
          if (stp.branch_based) {
            vm.conf.branch_based = stp.branch_based;
          }
          // if (stp.free_inscription_new_student) {
          //   vm.conf.free_inscription_new_student =
          //     stp.free_inscription_new_student;
          // }
          if (stp.run_on_student_selected) {
            vm.conf.run_on_student_selected = stp.run_on_student_selected;
          }
          if (stp.script_student_selected) {
            vm.conf.script_student_selected = stp.script_student_selected;
          }
          if (stp.run_script) {
            vm.conf.run_script = stp.run_script;
          }
          if (stp.script) {
            vm.conf.script = stp.script;
          }
          if (stp.print_receipt) {
            vm.conf.print_receipt = stp.print_receipt;
          }
          if (stp.create_portal_user) {
            vm.conf.create_portal_user = stp.create_portal_user;
          }
          if (stp.send_to_assignation) {
            vm.conf.send_to_assignation = stp.send_to_assignation;
          }
          if (stp.show_pensum_courses) {
            vm.conf.show_pensum_courses = stp.show_pensum_courses;
          }
          if (stp.show_pensum_courses) {
            vm.conf.show_pensum_courses = stp.show_pensum_courses;
          }
          if (stp.season_rule) {
            vm.conf.season_rule = stp.season_rule;
          }
          if (stp.season) {
            vm.conf.season = stp.season;
          }
          if (stp.receipt_layouts) {
            vm.$refs.templates.set_data(stp.receipt_layouts);
            // vm.conf.receipt_layouts = stp.receipt_layouts;
          }
          setTimeout(() => {
            window
              .jQuery(vm.$refs.tabs)
              .find(".item")
              .tab();
          }, 200);
        }
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    local_api(vm, "post", "/student_configuration/do-get-configuration")
      .then((conf) => {
        vm.branches = conf.std_branches;

        local_api(vm, "post", "/account_movement_type/do-get-list", {})
          .then((movementTypes) => {
            let vls = movementTypes.map((t) => {
              return { name: t.name, value: t.uuid };
            });
            let mmvntTypes = movementTypes.map((m) => {
              m.setup = JSON.parse(m.setup);
              return m;
            });
            window
              .jQuery(vm.$refs.movement_dropdown)
              .dropdown("setup menu", { values: vls })
              .dropdown({
                onChange(value) {
                  let trgtMovement = mmvntTypes.find((m) => m.uuid == value);
                  let amount =
                    trgtMovement && trgtMovement.setup
                      ? trgtMovement.setup.default_amount || 0
                      : 0;
                  let branchUuid = window.jQuery(this).data("branch");
                  let trgtSourceBranch = vm.branches.find((b) => {
                    return b.uuid == branchUuid;
                  });

                  let trgtBranch = vm.conf.branch_based.branches.find((b) => {
                    return b.branch.uuid == trgtSourceBranch.uuid;
                  });

                  if (!trgtBranch) {
                    vm.conf.branch_based.branches.push({
                      branch: trgtSourceBranch,
                      movements: [
                        { movement: trgtMovement, quantity: 1, amount: amount },
                      ],
                    });
                  } else {
                    trgtBranch.movements.push({
                      movement: trgtMovement,
                      quantity: 1,
                      amount: amount,
                    });
                  }

                  window
                    .jQuery(vm.$refs.movement_dropdown)
                    .dropdown("clear", true);
                },
              });
          })
          .catch((err) => {
            vm.$alertify.error(stringify(err));
          });

        vm.branches.map((b) => {
          let trgt = vm.conf.branch_based.branches.find(
            (br) => br.branch.uuid == b.uuid,
          );
          if (!trgt)
            vm.conf.branch_based.branches.push({ branch: b, movements: [] });
        });
        setTimeout(() => {
          window
            .jQuery(vm.$refs.branches_tabs)
            .find(".item")
            .tab();
        }, 500);
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    window
      .jQuery(vm.$refs.tabs_general)
      .find(".item")
      .tab();

    window.jQuery(vm.$refs.rule_dropdown).dropdown({
      onChange(value) {
        vm.conf.rule = value;
      },
    });
  },
  watch: {},
  updated: function() {},
};
</script>
